var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinActiveA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8.75,
    fill: "#66CCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4651 26.5656H37.7383V30.1885C38.786 28.1048 41.4729 26.2327 45.509 26.2327C53.2464 26.2327 55.0833 30.3804 55.0833 37.9905V52.0846H47.25V39.7236C47.25 35.3898 46.2023 32.9458 43.535 32.9458C39.8357 32.9458 38.2984 35.5798 38.2984 39.7217V52.0846H30.4651V26.5656ZM17.0329 51.7517H24.8662V26.2327H17.0329V51.7517ZM25.9883 17.9117C25.9886 18.5683 25.8584 19.2184 25.6053 19.8242C25.3521 20.43 24.9811 20.9795 24.5137 21.4406C23.5667 22.3819 22.2848 22.9087 20.9495 22.9055C19.6167 22.9046 18.3377 22.3791 17.3893 21.4426C16.9236 20.9799 16.5538 20.4298 16.3011 19.8239C16.0484 19.218 15.9178 18.5682 15.9166 17.9117C15.9166 16.5859 16.4454 15.3169 17.3913 14.3808C18.3389 13.4431 19.6183 12.9174 20.9515 12.918C22.2871 12.918 23.5678 13.4448 24.5137 14.3808C25.4576 15.3169 25.9883 16.5859 25.9883 17.9117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinActiveA);
export default __webpack_public_path__ + "static/media/linkedinActive_a.76f06d14c0b4dee795121802d05b29b6.svg";
export { ForwardRef as ReactComponent };